import { httpRequest } from "@/utils/HttpRequest";
import { IPage } from "@/types/ScmTypes";
import { ISupplierDetail, ISupplierSearchFields, ISupplierChangeData, ISupplierInsert, ISupplierUpdate, ISupplierPurchaseHistorySearchFields, ISupplierPurchaseHistoryDetail, ISupplierSupplyDetailsPageSearchFields, ISupplierSupplyDetails, ISupplierContractPageSearchFields, ISupplierContractDetails, ISupplierContractInsert, IFmsSupplierBillPageSearch, IFmsSupplierBillDetail, IFmsSupplierAccountShopPageSearch, IFmsSupplierAccountShopDetail, IFmsDictFindSearch, IFmsDictDetail,  } from "./supplierTypes";

export interface ISCMPage<T, S> extends IPage<T> {
    statistics: S
}

class SupplierService {
    //供应商列表
    async page(searchVo: ISupplierSearchFields) {
        const apiUrl = "/sum/supplier/findPage";
        return await httpRequest.post<IPage<ISupplierDetail>>(apiUrl, searchVo);
    }
    // 供应商启禁用
    async change(changeVo: ISupplierChangeData) {
        const apiUrl = "/sum/supplier/change";
        return await httpRequest.post<boolean>(apiUrl, changeVo);
    }
    // 供应商新增
    async insert(insertVo: ISupplierInsert) {
        const apiUrl = "/sum/supplier/insert";
        return await httpRequest.post<boolean>(apiUrl, insertVo);
    }
    // 供应商编辑
    async update(updateVo: ISupplierUpdate) {
        const apiUrl = "/sum/supplier/update";
        return await httpRequest.post<boolean>(apiUrl, updateVo);
    }
     // 供应商编辑
     async one(id: string) {
        const apiUrl = `/sum/supplier/findById/${id}`;
        return await httpRequest.get<ISupplierDetail>(apiUrl);
    }
     // 导出模版
     async exportTemplate() {
        const apiUrl = `/sum/supplier/downloadTpl`;
        return await httpRequest.getFile(apiUrl);
    }

    //采购历史
    async purchaseHistory(searchVo: ISupplierPurchaseHistorySearchFields) {
        const apiUrl = "/sum/supplier/purchase/history";
        return await httpRequest.post<IPage<ISupplierPurchaseHistoryDetail>>(apiUrl, searchVo);
    }
    
    //供货明细列表
    async supplyDetailsPage(searchVo: ISupplierSupplyDetailsPageSearchFields) {
        const apiUrl = "/sum/supply/findPage";
        return await httpRequest.post<IPage<ISupplierSupplyDetails>>(apiUrl, searchVo);
    }

    //导出供货明细模版
    async exportSupplyDetailsTemplate() {
        const apiUrl = `/sum/supply/downloadTpl`;
        return await httpRequest.getFile(apiUrl);
    }

    //供货明细导入明细
    async importSupplyDetails(file: File) {
        const apiUrl = `/sum/supply/import`;
        return await httpRequest.postFile(apiUrl, file);
    }

    //供货明细删除
    async deleteSupplyDetails(id: string) {
        const apiUrl = `/sum/supply/delete/${id}`;
        return await httpRequest.get<boolean>(apiUrl);
    }

    //供货明细编辑
     async SupplyDetailsUpdate(updateVo: ISupplierSupplyDetails) {
        const apiUrl = "/sum/supply/update";
        return await httpRequest.post<ISupplierSupplyDetails>(apiUrl, updateVo);
    }

    //供应商合同列表
    async supplierContractPage(searchVo: ISupplierContractPageSearchFields) {
        const apiUrl = "/sum/contrast/findPage";
        return await httpRequest.post<IPage<ISupplierContractDetails>>(apiUrl, searchVo);
    }

    //供应商合同新增
    async supplierContractInsert(insertVo: ISupplierContractInsert) {
        const apiUrl = "/sum/contrast/insert";
        return await httpRequest.post<boolean>(apiUrl, insertVo);
    }

    //供应商合同编辑
    async supplierContractUpdate(updateVo: ISupplierContractDetails) {
        const apiUrl = "/sum/contrast/update";
        return await httpRequest.post<boolean>(apiUrl, updateVo);
    }

    //供应商合同删除
    async supplierContractDelete(id: string) {
        const apiUrl = `/sum/contrast/delete/${id}`;
        return await httpRequest.get<boolean>(apiUrl);
    }

    //供应商采购账单信息
    async fmsSupplierBillPage(searchVo: IFmsSupplierBillPageSearch) {
        const apiUrl = `/fms/bill/page`;
        return await httpRequest.post<IPage<IFmsSupplierBillDetail>>(apiUrl, searchVo);
    }

    // 供应商账户查询
     async fmsSupplierAccountShopPage(searchVo: IFmsSupplierAccountShopPageSearch) {
        const apiUrl = `/fms/accountShop/find`;
        return await httpRequest.post<IFmsSupplierAccountShopDetail[]>(apiUrl, searchVo);
    }

    // 财务数据字典单个
    async fmsDictFind(searchVo: IFmsDictFindSearch) {
        const apiUrl = `/fms/dict/find`;
        return await httpRequest.post<IFmsDictDetail[]>(apiUrl, searchVo);
    }
  
}
    
export const supplierService = new SupplierService();